import { render, staticRenderFns } from "./FacebookPagePostList.vue?vue&type=template&id=0e1cd9bb"
import script from "./FacebookPagePostList.vue?vue&type=script&lang=js"
export * from "./FacebookPagePostList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports